export const ContainerInitial = {
  number: null,
  equipment_type: null,
  extra_gauge: null,
  seal: null,
  pieces: null,
  net_weight: null,
  gross_weight: null,
  volume: null,
};

export const CommodityInitialState = {
  commodity_id: null,
  importer_id: null,
  supplier_id: null,
  volume: null,
  pieces: null,
  net_weight: null,
  gross_weight: null,
  customer_reference_number: null,
  currency: null,
  invoice_value: null,
  supplier_invoice_number: null,
  origin_country: null,
  provenance_country: null,
  producer_id: null,
  producer_mill_id: null,
  cbam: false,
  production_method_id: null,
  melt_pour_country: null,
};

export const VoyageInitialState = {
  ocean_voyage: null,
  feeder_voyage: null,
  ocean_vessel_id: null,
  feeder_vessel_id: null,
  place_of_receipt_id: null,
  port_of_loading_id: null,
  date_of_departure: null,
  port_of_transshipment_id: null,
  etd_transshipment: null,
  eta_transshipment: null,
  place_of_delivery_id: null,
  port_of_discharge_id: null,
  eta_discharge: null,
};

export const SHARED_COLORS = [
  "#E3F2FD",
  "#FFFDE7",
  "#E0F2F1",
  "#FEEBEE",
  "#F3E5F5",
  "#FCE4EC",
  "#FFF3E0",
  "#F9FBE7",
  "#E8F5E9",
  "#E8EAF6",
] as const;
